




















import { useCustomersStore } from "@/store/useCustomersStore";
import { BFormCheckbox, BFormGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";

export default {
    components: { BFormGroup, BFormCheckbox },
    setup() {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        editableCustomerSettings.value.push("expandedTeamFilter");

        return {
            customerSettings,
        };
    },
};
